






























































import { Vue, Component } from 'vue-property-decorator';
import { LoginModel } from '@/services/core/AuthService';
import Form from '@/helpers/Form';

@Component({})
export default class Login extends Vue
{
    private message: string = '';
    private form: Form<LoginModel> = Form.create<LoginModel>({
        username: '',
        password: '',
        rememberMe: false
    });

    async onSubmit()
    {
        this.message = '';

        try
        {
            this.form.wait();
            this.$alert.close();
            this.message = '';

            await this.$auth.login(
                this.form.username,
                this.form.password,
                this.form.rememberMe,
                (token: any) =>
                {
                    let claimName = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
                    let claimValue = "GameAccess";

                    return claimName in token && ([].concat(token[claimName])).includes(claimValue);
                }
            );
        }
        catch (ex)
        {
            this.handleException(ex, {
                400: (ex: any) => this.message = ex.message,
                422: (ex: any) => this.form.$errors.record(ex.data.errors)
            });
            console.log(ex);
            console.log('blad');
        }
        finally
        {
            this.form.continue();
        }
    }
}
